import React, { useState, useEffect } from 'react'
import { Wallet } from 'lucide-react'
import '../css/classes/threeCards.css'

const LandmarkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-landmark-icon lucide-landmark">
    <path d="M10 18v-7"/>
    <path d="M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z"/>
    <path d="M14 18v-7"/>
    <path d="M18 18v-7"/>
    <path d="M3 22h18"/>
    <path d="M6 18v-7"/>
  </svg>
)

const HandCoinsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-hand-coins-icon lucide-hand-coins">
    <path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"/>
    <path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"/>
    <path d="m2 16 6 6"/>
    <circle cx="16" cy="9" r="2.9"/>
    <circle cx="6" cy="5" r="3"/>
  </svg>
)

const ThreeCards = ({ filterFromDate, filterToDate, filterApply }) => {
  const [expenseData, setExpenseData] = useState({
    totalExpense: 11000.0,
    numberOfTransactions: 5,
    averageCostPerTransaction: 2200.0
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchExpenseData = async () => {
      try {
        let monthToUse;
        
        if (filterApply && filterFromDate) {
          // Use the filtered month/year when filter is applied
          const filterDate = new Date(filterFromDate);
          monthToUse = filterDate.toLocaleString('en-US', { month: 'short', year: 'numeric' }).replace(' ', ' ');
        } else {
          // Use current month when no filter is applied or reset
          monthToUse = new Date().toLocaleString('en-US', { month: 'short', year: 'numeric' }).replace(' ', ' ');
        }
        
        const response = await fetch(`https://finance.infitouch.in/api/expenses/getExpenseOverviewDataByDateRange?month=${encodeURIComponent(monthToUse)}`, {
          method: 'GET',
          headers: {
            'X-Tenant-ID': 'cf',
            'Content-Type': 'application/json'
          }
        })
        
        if (response.ok) {
          const data = await response.json()
          setExpenseData({
            totalExpense: data.totalExpense,
            numberOfTransactions: data.numberOfTransactions,
            averageCostPerTransaction: data.averageCostPerTransaction
          })
        } else {
          // When API fails, set to null to indicate no data
          setExpenseData({
            totalExpense: null,
            numberOfTransactions: null,
            averageCostPerTransaction: null
          })
        }
      } catch (error) {
        console.error('Error fetching expense data:', error)
        // Keep default values if API fails
      } finally {
        setLoading(false)
      }
    }

    fetchExpenseData()
  }, [filterApply, filterFromDate, filterToDate])

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) {
      return '-'
    }
    return `₹${amount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
  }

  const formatNumber = (number) => {
    if (number === null || number === undefined) {
      return '-'
    }
    return number.toString()
  }

  return (
    <div className="three-cards-container">
      {/* Total Expense Card */}
      <div className="three-card three-card--expense">
        <div className="three-card__icon">
          <Wallet size={20} color="white" />
        </div>
        <div className="three-card__value">
          {loading ? '...' : formatCurrency(expenseData.totalExpense)}
        </div>
        <div className="three-card__label">
         Total Expense
        </div>
        <div className="three-card__subtitle">
          Expense
        </div>
      </div>

      {/* Number of Transactions Card */}
      <div className="three-card three-card--transactions">
        <div className="three-card__icon">
          <LandmarkIcon />
        </div>
        <div className="three-card__value">
          {loading ? '...' : formatNumber(expenseData.numberOfTransactions)}
        </div>
        <div className="three-card__label">
          Total Transaction
        </div>
        <div className="three-card__subtitle">
          Transaction
        </div>
      </div>

      {/* Average Cost Per Transaction Card */}
      <div className="three-card three-card--average">
        <div className="three-card__icon">
          <HandCoinsIcon />
        </div>
        <div className="three-card__value">
          {loading ? '...' : formatCurrency(expenseData.averageCostPerTransaction)}
        </div>
        <div style={{whiteSpace: 'nowrap'}} className="three-card__label">
          Average Expense Per Transaction
        </div>
        <div className="three-card__subtitle">
          Average
        </div>
      </div>
    </div>
  )
}

export default ThreeCards